import { render, staticRenderFns } from "./NewOrderModal.vue?vue&type=template&id=3460eb6a&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=ts"
export * from "./NewOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./NewOrderModal.vue?vue&type=style&index=0&id=3460eb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460eb6a",
  null
  
)

export default component.exports